"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletNumberConverter = void 0;
var tslib_1 = require("tslib");
var list_level_properties_1 = require("../numbering-lists/list-level-properties");
var ordinal_based_number_converter_1 = require("./ordinal-based-number-converter");
var BulletNumberConverter = (function (_super) {
    tslib_1.__extends(BulletNumberConverter, _super);
    function BulletNumberConverter() {
        var _this = _super.call(this) || this;
        _this.type = list_level_properties_1.NumberingFormat.Bullet;
        return _this;
    }
    BulletNumberConverter.prototype.convertNumberCore = function (_value) {
        return "•";
    };
    return BulletNumberConverter;
}(ordinal_based_number_converter_1.OrdinalBasedNumberConverter));
exports.BulletNumberConverter = BulletNumberConverter;
